(function (window, $j) {

    function onDocReady() {
        $j("body.brand-home-page .mw-content").css({
           "height": "calc(103px - 46px - " + $j(".navigation-overlay").outerHeight() + ")"
        });
        $j(window).resize(resizeFunction);
        $j(".navigation-container .navigation-overlay .nav-control").click(toggleSubNav);
    }

    function resizeFunction() {
        if($j(window).width() > 1024) {
            $j("body.brand-home-page .mw-content").css({
                "height": "calc(103px - 46px - " + $j(".navigation-overlay").outerHeight() + ")"
            });
        }
        else {
            $j("body.brand-home-page .mw-content").css({
                "height": "auto"
            });
        }
    }

    function toggleSubNav() {
        var container = $j(this).closest(".navigation-container");
        if(container.hasClass("open")) {
            container.removeClass("open");
            container.closest(".mw-hero").removeClass("sub-nav-open");
            $j("body").removeClass("no-scroll");
        }
        else {
            container.addClass("open");
            container.closest(".mw-hero").addClass("sub-nav-open");
            container.closest(".mw-hero").addClass("sub-nav-open");
            $j("body").addClass("no-scroll");
        }
    }

    $j(onDocReady);

    return {};

})(window,$j);